<div class="py-3 bg-dark-subtle text-center text-muted">
    <small>
        <a href="https://axon-soft.com/" class="text-muted">Axon-soft</a>
        &copy; {{currentYear}}</small
    >
</div>
